import { render } from "./SingleFilterView.vue?vue&type=template&id=796a5ee0&scoped=true"
import script from "./SingleFilterView.vue?vue&type=script&lang=js"
export * from "./SingleFilterView.vue?vue&type=script&lang=js"

import "./SingleFilterView.vue?vue&type=style&index=0&id=796a5ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796a5ee0"]])

export default __exports__